/* Asistente de ventas de Welding Republic — widget flotante del tema.
 *
 * Puerto a JS plano del widget React que vive en `warezomservicioaclientes`
 * (src/components/chatbot/*, src/lib/chatbot-session.ts). MISMO backend y MISMO
 * cerebro: POST a la Edge Function `chat-web-warezom`, que enruta al bot por el
 * campo `site`. Aquí siempre viaja `site: 'welding_republic'` → persona de
 * VENTAS con la tool `consultar_catalogo`.
 *
 * Contrato del endpoint (ver CLAUDE.md de aquel repo, sección F2):
 *   { session_id, text }              -> { reply, human:false, leadCaptured }
 *                                     -> { reply:null, human:true }  (takeover)
 *                                     -> 429 { error:'rate_limited' }
 *   { session_id, action:'history' }  -> { messages:[{role,content}], status }
 *
 * La configuración (endpoint, llave publishable, textos) la inyecta el snippet
 * `snippets/chat-wr.liquid` en `window.WRChatConfig`.
 */
(function () {
  'use strict';

  var cfg = window.WRChatConfig;
  if (!cfg || !cfg.endpoint || !cfg.publishableKey) return;
  // El widget es de la tienda pública: no tiene nada que hacer dentro del
  // editor de temas ni del checkout.
  if (window.Shopify && window.Shopify.designMode) return;

  var SESSION_KEY = 'wr_chat_session';
  var POLL_MS = 5000;
  var MAX_CHARS = 2000;

  /* ---------- sesión ---------- */

  // uuid v4 en localStorage: el backend RECHAZA cualquier otra cosa (400), y el
  // historial vive en servidor, así que debe sobrevivir el cierre de pestaña.
  function getSessionId() {
    var id = null;
    try {
      id = window.localStorage.getItem(SESSION_KEY);
    } catch (e) {
      /* modo privado o cookies bloqueadas: se opera sin persistir */
    }
    if (!id) {
      id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
      try {
        window.localStorage.setItem(SESSION_KEY, id);
      } catch (e) {
        /* ídem */
      }
    }
    return id;
  }

  var sessionId = getSessionId();
  var state = { open: false, human: false, sending: false, loaded: false };
  var pollTimer = null;

  /* ---------- render de texto ---------- */

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // El cerebro emite markdown; sin esto el cliente ve `**crudo**` y ligas sin
  // clickear (mismo gotcha que documenta el repo del bot para IG/FB).
  // Se escapa TODO primero y solo después se inyectan las etiquetas propias:
  // el texto viene de un LLM, o sea entrada no confiable.
  var TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|https?:\/\/[^\s)]+)/g;

  function renderRich(text) {
    return String(text)
      .split(TOKEN)
      .map(function (part) {
        if (!part) return '';
        var bold = part.match(/^\*\*([^*]+)\*\*$/);
        if (bold) return '<strong>' + renderRich(bold[1]) + '</strong>';
        var md = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (md) return link(md[2], md[1]);
        if (/^https?:\/\//.test(part)) return link(part, part);
        return escapeHtml(part);
      })
      .join('');
  }

  // Solo http(s) y rutas internas de la tienda. Cualquier otro esquema
  // (javascript:, data:) se queda como texto plano.
  function link(href, label) {
    var safe = /^https?:\/\//i.test(href) || href.charAt(0) === '/';
    if (!safe) return escapeHtml(label);
    var external = /^https?:\/\//i.test(href);
    return (
      '<a href="' + escapeHtml(href) + '"' +
      (external ? ' target="_blank" rel="noopener noreferrer"' : '') +
      '>' + escapeHtml(label) + '</a>'
    );
  }

  /* ---------- DOM ---------- */

  var root = document.createElement('div');
  root.className = 'wrchat';
  root.setAttribute('data-open', 'false');
  root.setAttribute('data-human', 'false');
  root.innerHTML = [
    '<div class="wrchat__panel" role="dialog" aria-modal="false" aria-label="' +
      escapeHtml(cfg.headerName) + '">',
    '  <div class="wrchat__header">',
    '    <div class="wrchat__avatar" aria-hidden="true">⚡</div>',
    '    <div class="wrchat__title">',
    '      <div class="wrchat__name">' + escapeHtml(cfg.headerName) + '</div>',
    '      <div class="wrchat__role">' + escapeHtml(cfg.headerRole) + '</div>',
    '    </div>',
    '    <button type="button" class="wrchat__close" aria-label="Cerrar chat">✕</button>',
    '  </div>',
    '  <p class="wrchat__notice">Un asesor está atendiendo tu conversación \u{1F464}</p>',
    '  <div class="wrchat__log" role="log" aria-live="polite"></div>',
    '  <form class="wrchat__form">',
    '    <input class="wrchat__input" type="text" autocomplete="off" maxlength="' + MAX_CHARS +
      '" placeholder="' + escapeHtml(cfg.placeholder) + '" aria-label="Escribe tu mensaje">',
    '    <button type="submit" class="wrchat__send">Enviar</button>',
    '  </form>',
    '</div>',
    '<button type="button" class="wrchat__launcher" aria-label="' +
      escapeHtml(cfg.launcherAria) + '">',
    '  <span class="wrchat__launcher-icon" aria-hidden="true">\u{1F4AC}</span>',
    '  <span>' + escapeHtml(cfg.launcherLabel) + '</span>',
    '</button>',
  ].join('');

  var panel = root.querySelector('.wrchat__panel');
  var log = root.querySelector('.wrchat__log');
  var form = root.querySelector('.wrchat__form');
  var input = root.querySelector('.wrchat__input');
  var sendBtn = root.querySelector('.wrchat__send');
  var launcher = root.querySelector('.wrchat__launcher');

  function addMessage(role, content) {
    var el = document.createElement('div');
    el.className = 'wrchat__msg wrchat__msg--' + (role === 'user' ? 'user' : 'bot');
    el.innerHTML = renderRich(content);
    log.appendChild(el);
    scrollDown();
    return el;
  }

  function setStatus(text, isError) {
    clearStatus();
    if (!text) return;
    var el = document.createElement('div');
    el.className = 'wrchat__status' + (isError ? ' wrchat__status--error' : '');
    el.dataset.wrchatStatus = '1';
    el.textContent = text;
    log.appendChild(el);
    scrollDown();
  }

  function clearStatus() {
    var old = log.querySelectorAll('[data-wrchat-status]');
    for (var i = 0; i < old.length; i++) old[i].remove();
  }

  function scrollDown() {
    log.scrollTop = log.scrollHeight;
  }

  function setHuman(isHuman) {
    state.human = !!isHuman;
    root.setAttribute('data-human', state.human ? 'true' : 'false');
    // El polling solo tiene sentido en takeover: fuera de ahí la respuesta del
    // bot llega en la misma respuesta HTTP.
    if (state.human && state.open) startPolling();
    else stopPolling();
  }

  /* ---------- red ---------- */

  function call(body) {
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: cfg.publishableKey,
        Authorization: 'Bearer ' + cfg.publishableKey,
      },
      body: JSON.stringify(
        Object.assign({ session_id: sessionId, site: 'welding_republic' }, body)
      ),
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    });
  }

  function loadHistory() {
    return call({ action: 'history' }).then(function (r) {
      if (!r.ok || !r.data) return;
      log.innerHTML = '';
      addMessage('assistant', cfg.greeting);
      var msgs = r.data.messages || [];
      for (var i = 0; i < msgs.length; i++) {
        addMessage(msgs[i].role, msgs[i].content);
      }
      setHuman(r.data.status === 'human');
      state.loaded = true;
    }).catch(function () {
      /* sesión nueva o red caída: el saludo ya está pintado */
    });
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = window.setInterval(function () {
      // Pestaña oculta = no gastar red (misma regla que el widget de Marlene).
      if (document.hidden) return;
      loadHistory();
    }, POLL_MS);
  }

  function stopPolling() {
    if (!pollTimer) return;
    window.clearInterval(pollTimer);
    pollTimer = null;
  }

  function send(text) {
    state.sending = true;
    sendBtn.disabled = true;
    addMessage('user', text);
    setStatus(cfg.sending, false);

    call({ text: text }).then(function (r) {
      clearStatus();
      if (r.status === 429) {
        setStatus('Vas muy rápido \u{1F605} espera unos segundos y sigue.', true);
        return;
      }
      if (!r.ok) throw new Error('chat failed');
      if (r.data.human) {
        // El reply llegará por polling cuando el asesor conteste.
        setHuman(true);
        return;
      }
      if (r.data.reply) addMessage('assistant', r.data.reply);
      else throw new Error('empty reply');
    }).catch(function () {
      clearStatus();
      setStatus(cfg.error, true);
    }).finally(function () {
      state.sending = false;
      sendBtn.disabled = false;
    });
  }

  /* ---------- eventos ---------- */

  function open() {
    state.open = true;
    root.setAttribute('data-open', 'true');
    if (!state.loaded) {
      addMessage('assistant', cfg.greeting);
      loadHistory();
    }
    if (state.human) startPolling();
    input.focus();
  }

  function close() {
    state.open = false;
    root.setAttribute('data-open', 'false');
    stopPolling();
    launcher.focus();
  }

  launcher.addEventListener('click', open);
  panel.querySelector('.wrchat__close').addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || state.sending) return;
    input.value = '';
    send(text.slice(0, MAX_CHARS));
  });

  document.addEventListener('visibilitychange', function () {
    // Al volver a la pestaña durante un takeover, refrescar de inmediato en vez
    // de esperar el siguiente tick del intervalo.
    if (!document.hidden && state.open && state.human) loadHistory();
  });

  // API mínima para otras piezas del tema (hoy: el selector de máquina en
  // /pages/selector). Abre el chat con un mensaje precargado que la persona
  // revisa y manda ella misma — nada se envía sin su clic.
  window.WRChat = {
    open: function (prefill) {
      open();
      if (typeof prefill === 'string' && prefill) {
        input.value = prefill.slice(0, MAX_CHARS);
        input.focus();
      }
    },
  };

  document.body.appendChild(root);
})();
